export enum DemoSetupStep {
  CONFIGURE_DEMO = 'configure_demo',
  GENERATING_DEMO = 'generating_demo',
}
